"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "occhieppo-superiore": {
    "a0afc6c2": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "fiario": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ace6ded2": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "galfione": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5c82014e": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "pasquario": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f4601561": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "be526cd2",
      "slug": "occhieppo-superiore",
      "name": "Occhieppo Superiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;